module.exports = __webpack_public_path__ + "static/media/ATG.51e3f4c3.svg";